import {
  LocalGridType,
  ProviderDemandFragment,
  ProviderFragment,
  ProviderType,
} from '../generated/graphql'
import { SpecialDemand } from '../calculators/special-demand-ids'

export const localGridTypeToProviderTypeMap = {
  [LocalGridType.Water]: ProviderType.LocalWaterGrid,
  [LocalGridType.Electricity]: ProviderType.LocalElectricalGrid,
}

/**
 * Local grid providers don't have demands like buildings, so we have to add
 * the custom building and local water grid demands manually.
 *
 * We could consider supporting these on the database level but that would be a large change requiring delicate migration in addition to code changes.
 */
export function getLocalGridProviderDemands(
  localGridType: LocalGridType,
): ProviderDemandFragment[] {
  const demands = [
    {
      demand: { id: SpecialDemand.Buildings },
      maxPortion: 1,
    } as ProviderDemandFragment,
  ]
  if (localGridType === LocalGridType.Electricity) {
    return [
      ...demands,
      {
        demand: { id: SpecialDemand.LocalWaterGrid },
        maxPortion: 1,
      } as ProviderDemandFragment,
    ]
  }
  return demands
}

export function addDemandsToLocalGridProviders(localGridType: LocalGridType) {
  return (provider: ProviderFragment): ProviderFragment => ({
    ...provider,
    demands: getLocalGridProviderDemands(localGridType),
  })
}
